import RenderHtml from '../../../../components/RenderHtml';

const StepThree = ({ data, declaration, onUpdate }) => {
  const accepted = data?.accepted || false

  return (
    <div className="space-y-6">
      <div className="border border-gray-300 rounded-md p-4 text-sm text-gray-700">
        <h3 className="font-semibold mb-2">Declaration Statement</h3>
        <RenderHtml htmlString={declaration} />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">I have read and accept the declaration</label>
        <div
          className={`relative inline-flex w-11 shrink-0 rounded-full p-0.5 transition-colors duration-200 ease-in-out ${accepted ? 'bg-indigo-600' : 'bg-gray-200'
            }`}
        >
          <input
            id="phased-return-toggle"
            name="phased-return"
            type="checkbox"
            className="peer absolute inset-0 z-10 opacity-0 cursor-pointer"
            checked={accepted}
            onChange={(event) => onUpdate?.({ accepted: event.target.checked })}
            aria-label="Use setting"
          />
          <span className="relative size-5 rounded-full bg-white shadow-xs ring-1 ring-gray-900/5 transition-transform duration-200 ease-in-out peer-checked:translate-x-5">
            {accepted ? (
              <span className="absolute inset-0 flex items-center justify-center">
                <svg fill="currentColor" viewBox="0 0 12 12" className="size-3 text-indigo-600">
                  <path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
                </svg>
              </span>
            ) : (
              <span className="absolute inset-0 flex items-center justify-center">
                <svg fill="none" viewBox="0 0 12 12" className="size-3 text-gray-400">
                  <path
                    d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            )}
          </span>
        </div>
      </div>

      {/* {accepted && (
        <div>
          <button className="px-4 py-2 text-sm font-medium text-white bg-sas rounded-md hover:bg-sas-dark" onClick={submitClaim}>Confirm</button>
        </div>
      )} */}

    </div>
  );
};

export default StepThree;
